export default {
  openButton: "Generate descriptors with AI",
  title: "Quick creation with AI — {entity}",
  close: "Close",
  // Fallbacks for the institutional alternative names.
  matterProgramLabel: "Matter Program",
  matterLabel: "the Matter",
  descriptors: "{entity} Descriptors",
  noDescriptors: "The institution has no descriptors defined for {entity}.",
  generating: "Generating content with AI...",
  generateError: "The content could not be generated. Please try again later.",
  cancel: "Cancel",
  confirmSave: "Confirm and save",
  savedToast: "Objects created successfully.",
  saveError:
    "An error occurred while saving the generated objects. Please try again.",
};
